import styled, { css } from 'styled-components'
import colors from 'Assets/colors'
import { media } from 'Config/styled'
import { ORDER_STATUS } from 'Config/constants'

export const RequestActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: ${props => (props.smallCard ? '0' : '20px')};
  border: ${props =>
    props.smallCard && props.status === ORDER_STATUS.PR
      ? 'none'
      : props.smallCard && props.disabled
      ? '1px solid rgba(51, 51, 51, 0.2)'
      : props.smallCard
      ? '1px solid rgba(51, 51, 51, 0.70)'
      : 'none'};
  padding-right: ${props => (props.smallCard ? '20px' : '0')};
  padding-left: ${props => (props.smallCard ? '20px' : '0')};
  border-radius: 8px;
  background: ${props => (props.smallCard && props.status === ORDER_STATUS.PR ? props.theme.colors.secondary : 'auto')};

  height: ${props => (props.smallCard ? '50px' : '100%')};
  ${media('lg')} {
    margin-right: 0;
    flex: ${props => (props.smallCard ? 1 : 0)};
    align-items: ${props => (props.smallCard ? 'center' : 'auto')};
  }

  :hover {
    opacity: 0.6;
    background-color: ${props => props.theme.colors[props.color]};
  }
`

export const RequestRepeatOrder = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  margin-bottom: ${props => (props.smallCard ? '0' : '8px')};

  ${p =>
    !p.disabled &&
    css`
      &:hover {
        svg {
          path {
            fill: ${colors.secondary};
          }
        }
      }
    `}

  svg {
    margin-right: 18px;
    width: 24px;
    path {
      transition: all 0.2s;
      fill: ${p => (p.disabled ? colors.grey4 : p.color)};
    }
  }
  button {
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: ${p =>
      p.disabled ? colors.grey4 : p.smallCard && p.status === ORDER_STATUS.PR ? colors.white : colors.black};
    margin-left: -5px;
    cursor: ${p => (p.disabled ? 'auto' : 'pointer')};
    transition: all 0.2s;
  }
`

export const HelpText = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: ${p => (p.disabled ? colors.grey4 : colors.gray40l)};
  margin-left: 38px;

  ${props =>
    props.bold &&
    css`
      color: ${colors.blue};
      font-weight: 700;
    `}
`
